var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<md-content layout-padding class=\"md-caption\"> <md-card> <md-card-content> <h2 class=\"md-title\">And more</h2> <p> Need help with your income tax filing? Check out this site about <a href=\"#\" ng-click=\"$ctrl.goPartner()\">dutch income tax return filing</a>. </p> </md-card-content> </md-card> </md-content>";
ngModule.run(["$templateCache",function(c){c.put("src/parner-section/partner-section.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./parner-section/partner-section.html
 ** module id = 13
 ** module chunks = 0
 **/